import styled from 'styled-components';

export const StyledPayHeaderElement = styled.div`
    width: 19.5%;
`;
